<template>
  <button @click="toggleExpansion" @mouseup.stop :class="[modelValue && 'upside-down','toggle-btn']">
    <span class="fa-layers fa-sm">
      <font-awesome-icon :icon="['fas','chevron-down']" transform="up-4"/>
      <font-awesome-icon :icon="['fas','chevron-down']" transform="down-4"/>
    </span>
  </button>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

function toggleExpansion() {
  emit('update:modelValue', !props.modelValue);
}
</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

  .toggle-btn {
    transition: 0.25s transform;
    &:focus {
      box-shadow: none !important;
    }
    &:active {
      background-color: $bgColour !important;
      border-color: $bgColour !important;
    }
  }

  .upside-down {
    transform: rotate(-180deg);
  }


</style>